<template>
  <div id="TabBarContent">
      <keep-alive>
        <router-view  v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
<!--    <transition :name="transitionName">-->
        <router-view v-if="!$route.meta.keepAlive"></router-view>
<!--    </transition>-->
    <tab-bar :tabbars="tabbars" v-if="this.$route.meta.showTab"></tab-bar>
  </div>
</template>

<script>
import TabBar from "@/components/common/tabbar/TabBar";

export default {
  name: "TabBarContent",
  components: {
    TabBar: TabBar
  },
  data(){
    return{
      transitionName: 'fold-left',
      tabbars: [
        {
          name: "home",
          title: "首页",
          // normal: 'wap-home'
          normal: require("@/assets/image/tabbar/home.png"),
          // active: require("@/assets/image/icon/home_selected.png")
        },
        {
          name: "category",
          title: "分类",
          // normal: 'bars'

          normal: require("@/assets/image/tabbar/fenlei.png"),
          // active: require("@/assets/image/icon/category_selected.png")
        },
        // {
        //   name: "special",
        //   title: "专题",
        //   normal: 'column'
        // normal: require("@/assets/image/icon/special.png"),
        //   // active: require("@/assets/image/icon/special_selected.png")
        // },
        {
          name: 'order/shoppingCart',
          title: "购物车",
          // normal: 'shopping-cart'
          normal: require("@/assets/image/tabbar/shopcar.png"),
        },
        {
          name: "mine",
          title:"我的",
          // normal: 'manager'
          normal: require("@/assets/image/tabbar/wode.png"),
          // active: require("@/assets/image/icon/my_selected.png")
        }
      ],
    }
  },
  created(){

  },
  watch: {
    $route(to, from) {
      // var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      // this.scrollMap[from.path] = scrollTop;
      // localStorage.setItem("scroMap", JSON.stringify(this.scrollMap));
        //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      // console.log(to.meta);
        if(to.meta.showTab){
          this.transitionName = 'fold-right';
        }else{
          this.transitionName = 'fold-left';
        }
    },
    updated() {

    }
  }
}
</script>

<style scoped>
.all-content {
  margin-bottom: 40px;
}

</style>
